module.exports = __webpack_public_path__ + "img/05_sub_uk.7e1417c6.svg";